<script setup lang="ts">
import type { ARServiceItem } from '@/models/airRoad';

import KTextField from '@/components/fields/KTextField.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

const model = defineModel<ARServiceItem>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.newAirRoadSpecialOptionUnpackFieldset"
    data-testid="newAirRoadSpecialOptionUnpackFieldset"
  >
    <KTextField
      v-model="model.description"
      size="sm"
      label="Description"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionUnpackFieldset {
}
  .field {
    margin-top: 0.5rem;
  }
</style>
